import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import SectionLayout from '../components/section-layout'

const FishingPage = () => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(filter: { frontmatter: { tags: { eq: "fishing" } } }) {
        edges {
          node {
            frontmatter {
              title
              slug
              featuredImage {
                childImageSharp {
                  fluid(maxWidth: 800) {
                    src
                  }
                }
              }
            }
          }
        }
      }
      hero: file(relativePath: { eq: "fishing-page.jpg" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  `)

  return <SectionLayout pageTitle="Fishing" data={data} />
}

export default FishingPage
